import Home from './components/home';
import Header from './components/header';

import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <Home />
    </div>
  );
}

export default App;
